import { SafeHydrate } from "@/SafeHydrate";
import { ArrowRight, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ReadyToVisit() {
  return <section data-section-id="261621" id="ready-to-visit" className="bg-background py-24 text-foreground">
      <div className="page-container">
        <div className="relative overflow-hidden rounded-3xl bg-white px-6 py-20 text-center shadow-xl sm:px-16 sm:py-24 lg:px-24 border border-border">
          {}
          <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
            <div className="absolute -top-24 -right-24 h-96 w-96 rounded-lg bg-primary/5 blur-[100px]"></div>
            <div className="absolute -bottom-24 -left-24 h-96 w-96 rounded-lg bg-chart-2/5 blur-[100px]"></div>
            
            {}
            <div className="absolute inset-0 opacity-[0.05]" style={{
            backgroundImage: 'radial-gradient(circle at center, hsl(215 60% 52%) 1px, transparent 1px)',
            backgroundSize: '32px 32px'
          }}></div>
          </div>

          {}
          <div className="relative z-10 mx-auto max-w-4xl">
            <h2 className="font-default text-4xl font-semibold tracking-tight text-foreground sm:text-5xl md:text-6xl">
              Ready to Visit Happy Paws?
            </h2>
            <p className="mx-auto mt-6 max-w-2xl text-lg text-muted-foreground sm:text-xl font-default">
              Our clinic is open Monday – Friday: 8am – 6pm and Saturday: 9am – 2pm. We can't wait to meet your furry family members.
            </p>
            
            <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
              <Link to="/ContactPage">
                <Button size="lg" className="h-14 w-full rounded-lg px-8 text-base font-semibold shadow-lg shadow-primary/20 transition-all hover:scale-105 sm:w-auto bg-primary text-primary-foreground">
                  <SafeHydrate><Calendar className="mr-2 size-5" /></SafeHydrate>
                  Book an Appointment
                </Button>
              </Link>
              
              <Link to="/ServicesPage">
                <Button size="lg" variant="outline" className="h-14 w-full rounded-lg border-border bg-white/50 px-8 text-base font-semibold text-foreground backdrop-blur-sm transition-all hover:bg-accent hover:text-accent-foreground sm:w-auto">
                  View Our Services
                  <ArrowRight className="ml-2 size-5" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}